import {version} from '../package.json'

export const config = {
    mantainance: false,
    bundle: "shop.progetto.missbaby",
    version: "2.2.5",
    refreshTokenAdvance: 300, //seconds before expire
    apiKey: "ef7660a5-fc6c-11ec-86b6-960001637d0e",
    baseurl: "https://missbaby-api.progetto.shop",
    defaultLanguage: { code: "it", label: "Italian" },
    languages: [
        { code: "gb", label: "English" },
        { code: "it", label: "Italian" },
    ],
    tab_channel: {
        device: "shop.progetto.missbaby/device",
        mainTab: "shop.progetto.missbaby/main-tab"
    },
    push_notification: {
        enabled: false,
        apiKey: "xxx",
        config: {  // WARNING: Remember to copy this params in /public/firebase-messaging-sw.js
            apiKey: "...",
            authDomain: "...",
            projectId: "...",
            storageBucket: "...",
            messagingSenderId: "...",
            appId: "...",
            measurementId: "..."
        }
    },
    restError: {
        BadRequest: "1000",
        PreconditionFailed: "6000",
        Forbidden: "8000",
    }
};